import { FC } from 'react';
import { ReactComponent as CloseIcon } from 'assets/close-icon.svg';

export const CloseButton: FC<{ onClick: any }> = ({ onClick }) => {
	return <CloseIcon onClick={onClick} fill="#FF5055" className="mt-4 mr-4 cursor-pointer float-right" />;
};

export const CloseButtonUnstyleed: FC<{ onClick: any }> = ({ onClick }: { onClick: any }) => {
	return <CloseIcon onClick={onClick} fill="#FF5055" className="cursor-pointer" />;
};
